import * as stagesCase from "../../Stages/StagesCase";
import { ProductSpecificFormDefinition } from "../../../types/ProductService/ProductService";
import { EmploymentContract } from "../../../types/Products/EmploymentLaw/EmploymentContract";

const employmentContractSpecificDefinition = (
  product: EmploymentContract
): ReturnType<ProductSpecificFormDefinition<EmploymentContract>> => [
  {
    type: "ValidatorDateField",
    path: `${product.productClassName}.endOfContractDate`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
  },
];

export default employmentContractSpecificDefinition;
